import { configGetLanguage } from 'common/helper/config/get-language';
import { configGetSettings } from 'common/helper/config/get-settings';
import { UserSignInStatsStore } from 'common/module/user/sign-in/stats/store';
import { StatsGtmProviderService } from 'common/service/stats-gtm-provider/service';
import { StatsSnowplow2ProviderService } from 'common/service/stats-snowplow2-provider/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { UserSignIn2InteractionService } from 'common/service/user-sign-in2-interaction/service';

const service = new UserSignInStatsStore(
  UserAuthenticationService(),
  StatsGtmProviderService(),
  StatsSnowplow2ProviderService(),
  configGetLanguage(),
  configGetSettings(),
  UserSignIn2InteractionService()
);

service.initialize();

export const UserSignInStatsService = () => service;
